module.exports = __webpack_public_path__ + "assets/roboto-v30-latin_latin-ext-900italic.58d707d594c8ae29f86644084a3a91f5.woff2";